import { Component } from "react";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  Spinner,
} from "reactstrap";
import { login, registerComplete } from "../../Redux/Actions/authAction";
import email from "../../assets/img/dashboard-Slicing/Email.svg";
import password from "../../assets/img/dashboard-Slicing/Password.svg";
import close from "../../assets/img/dashboard-Slicing/close.svg";

class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
    };
  }

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  componentDidMount() {
    this.props.authComplete();
  }

  render() {
    const { uid, loading, isOpen, toggle } = this.props;

    if (uid) {
      toggle(); // Close modal on successful login
      return <Redirect to="/admin/index" />;
    }

    return (
      <Modal isOpen={isOpen} toggle={toggle} centered size="md">
        <ModalBody className="p-4 rounded" style={{ borderRadius: "16px" }}>
          <div className="text-right d-flex pt-0 pb-2">
            <span className="ml-auto mt-auto mb-auto" onClick={toggle}>
              <img src={close} alt="icon" width="40px" className="close-AM" />
            </span>
          </div>

          <div className="text-center mb-4">
            <h3 className="mt-3 mb-5 lgn-heading">Login to Merk Mobile</h3>
          </div>

          <Form
            role="form"
            onSubmit={(e) => {
              e.preventDefault();
              let creds = {
                email: this.state.email,
                password: this.state.password,
              };
              console.log("login creds", creds);
              this.props.authLogin(creds);
            }}
          >
            <FormGroup className="mb-3">
              <div className="position-relative form-box">
                <div className="position-absolute form-icon" left="10">
                  <img src={email} alt="icon" width="16px" />
                </div>
                <Input
                  onChange={this.handleInput}
                  placeholder="Email"
                  name="email"
                  type="email"
                  required
                  autoComplete="new-email"
                  className="pl-5 py-4 shadow-sm border-0 rounded"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    fontSize: "14px",
                    borderRadius: "8px"
                  }}
                />
              </div>
            </FormGroup>

            <FormGroup>
              <div className="position-relative form-box">
                <div className="position-absolute form-icon" left="10">
                  <img src={password} alt="icon" width="14px" />
                </div>
                <Input
                  onChange={this.handleInput}
                  placeholder="Password"
                  name="password"
                  type="password"
                  required
                  className="pl-5 py-4 shadow-sm border-0 rounded"
                  style={{
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #e9ecef",
                    fontSize: "14px",
                    borderRadius: "8px"
                  }}
                />
              </div>
              <div className="w-100 d-flex justify-content-end p-0">
                <Link
                  to={{ pathname: "/auth/forget-password" }}
                  className="text-site-primary mt-1"
                >
                  forgot password?
                </Link>
              </div>
            </FormGroup>

            <div className="text-center">
              <Button 
                className="my-3 w-100 bg-site-primary shadow login-btn rounded"
                style={{
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: "600",
                  border: "none",
                  borderRadius: "8px"
                }}
              >
                {loading ? <Spinner size="sm" /> : "Log in"}
              </Button>
            </div>
          </Form>

          <div className="text-center">
            Don't have an account?
            <span
              className="text-site-primary ml-1 cursor-pointer"
              onClick={() => {
                toggle();
                this.props.showRegisterModal();
              }}
            >
              Sign Up
            </span>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export function mapStateToProps(state) {
  return {
    uid: state.auth.uid,
    loading: state.auth.requested,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    authLogin: (creds) => dispatch(login(creds)),
    authComplete: () => dispatch(registerComplete()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);
